export const FETCH_LOGIN_REQUEST = 'FETCH_LOGIN_REQUEST';
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS';
export const FETCH_POST_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_FAILED = 'FETCH_LOGIN_FAILED';
export const FETCH_LOGIN_MFA_SUCCESS = 'FETCH_LOGIN_MFA_SUCCESS';

export const FETCH_OAUTH_LOGIN_SUCCESS = 'FETCH_OAUTH_LOGIN_SUCCESS';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';

export const FETCH_MFA_REQUEST = 'FETCH_MFA_REQUEST';
export const FETCH_MFA_SUCCESS = 'FETCH_MFA_SUCCESS';
export const FETCH_MFA_FAILED = 'FETCH_MFA_FAILED';

export const FETCH_REFRESH_TOKEN_REQUEST = 'FETCH_REFRESH_TOKEN_REQUEST';
export const FETCH_REFRESH_TOKEN_SUCCESS = 'FETCH_REFRESH_TOKEN_SUCCESS';
export const FETCH_REFRESH_TOKEN_FAILED = 'FETCH_REFRESH_TOKEN_FAILED';

export const FETCH_FORGOT_PASSWORD_REQUEST = 'FETCH_FORGOT_PASSWORD_REQUEST';
export const FETCH_FORGOT_PASSWORD_SUCCESS = 'FETCH_FORGOT_PASSWORD_SUCCESS';
export const FETCH_FORGOT_PASSWORD_FAILED = 'FETCH_FORGOT_PASSWORD_FAILED';

export const FETCH_SET_PASSWORD_REQUEST = 'FETCH_SET_PASSWORD_REQUEST';
export const FETCH_SET_PASSWORD_SUCCESS = 'FETCH_SET_PASSWORD_SUCCESS';
export const FETCH_SET_PASSWORD_FAILED = 'FETCH_SET_PASSWORD_FAILED';
export const FETCH_RESET_PASSWORD = 'FETCH_RESET_PASSWORD';

export const FETCH_CHANGE_PASSWORD_REQUEST = 'FETCH_CHANGE_PASSWORD_REQUEST';
export const FETCH_CHANGE_PASSWORD_SUCCESS = 'FETCH_CHANGE_PASSWORD_SUCCESS';
export const FETCH_CHANGE_PASSWORD_FAILED = 'FETCH_CHANGE_PASSWORD_FAILURE';

export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST';
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILED = 'RESEND_OTP_FAILED';

export const FETCH_EMAIL_CONFIRM_REQUEST = 'FETCH_EMAIL_CONFIRM_REQUEST';
export const FETCH_EMAIL_CONFIRM_SUCCESS = 'FETCH_EMAIL_CONFIRM_SUCCESS';
export const FETCH_EMAIL_CONFIRM_FAILED = 'FETCH_EMAIL_CONFIRM_FAILED';

export const FETCH_BASTIONS_REQUEST = 'FETCH_BASTIONS_REQUEST';
export const FETCH_BASTIONS_SUCCESS = 'FETCH_BASTIONS_SUCCESS';
export const FETCH_BASTIONS_FAILED = 'FETCH_BASTIONS_FAILED';
export const FETCH_RESET_BASTIONS = 'FETCH_RESET_BASTIONS';
export const SET_CURRENT_BASTION = 'SET_CURRENT_BASTION';

export const FETCH_UPDATE_ACCOUNT_REQUEST = 'FETCH_UPDATE_ACCOUNT_REQUEST';
export const FETCH_UPDATE_ACCOUNT_SUCCESS = 'FETCH_UPDATE_ACCOUNT_SUCCESS';
export const FETCH_UPDATE_ACCOUNT_FAILED = 'FETCH_UPDATE_ACCOUNT_FAILED';

export const FETCH_ACCESS_TOKEN_REQUEST = 'FETCH_ACCESS_TOKEN_REQUEST';
export const FETCH_ACCESS_TOKEN_SUCCESS = 'FETCH_ACCESS_TOKEN_SUCCESS';
export const FETCH_ACCESS_TOKEN_FAILED = 'FETCH_ACCESS_TOKEN_FAILED';

export const RESET_VERIFICATION_CODE = 'RESET_VERIFICATION_CODE';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';

export const RESET_OTP_SUCCESS = 'RESET_OTP_SUCCESS';
export const SWITCH_ORGANIZATION = 'SWITCH_ORGANIZATION';

export const FETCH_UNAUTHORIZED = 'FETCH_UNAUTHORIZED';
export const FETCH_UNAUTHORIZED_PAGE = 'FETCH_UNAUTHORIZED_PAGE';

export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILED = 'FETCH_CLIENTS_FAILED';

export const FETCH_START_TWO_FACTOR_REQUEST = 'FETCH_START_TWO_FACTOR_REQUEST';
export const FETCH_START_TWO_FACTOR_SUCCESS = 'FETCH_START_TWO_FACTOR_SUCCESS';
export const FETCH_START_TWO_FACTOR_FAILED = 'FETCH_START_TWO_FACTOR_FAILED';

export const FETCH_TWO_FACTOR_CONFIG_REQUEST = 'FETCH_TWO_FACTOR_CONFIG_REQUEST';
export const FETCH_TWO_FACTOR_CONFIG_SUCCESS = 'FETCH_TWO_FACTOR_CONFIG_SUCCESS';
export const FETCH_TWO_FACTOR_CONFIG_FAILED = 'FETCH_TWO_FACTOR_CONFIG_FAILED';

export const SET_TWO_FACTOR_CONFIG_REQUEST = 'SET_TWO_FACTOR_CONFIG_REQUEST';
export const SET_TWO_FACTOR_CONFIG_SUCCESS = 'SET_TWO_FACTOR_CONFIG_SUCCESS';
export const SET_TWO_FACTOR_CONFIG_FAILED = 'SET_TWO_FACTOR_CONFIG_FAILED';

export const FETCH_TWO_FACTOR_LOGIN_REQUEST = 'FETCH_TWO_FACTOR_LOGIN_REQUEST';
export const FETCH_TWO_FACTOR_LOGIN_SUCCESS = 'FETCH_TWO_FACTOR_LOGIN_SUCCESS';
export const FETCH_TWO_FACTOR_LOGIN_FAILED = 'FETCH_TWO_FACTOR_LOGIN_FAILED';

export const CHANGE_POSITION = 'CHANGE_POSITION';

export const ENABLE_IDP_FORM = 'ENABLE_IDP_FORM';

export const FETCH_UPSERT_IDENTITY_PROVIDER_REQUEST = 'FETCH_UPSERT_IDENTITY_PROVIDER_REQUEST';
export const FETCH_UPSERT_IDENTITY_PROVIDER_SUCCESS = 'FETCH_UPSERT_IDENTITY_PROVIDER_SUCCESS';
export const FETCH_UPSERT_IDENTITY_PROVIDER_FAILED = 'FETCH_UPSERT_IDENTITY_PROVIDER_FAILED';

export const FETCH_IDENTITY_PROVIDER_REQUEST = 'FETCH_IDENTITY_PROVIDER_REQUEST';
export const FETCH_IDENTITY_PROVIDER_SUCCESS = 'FETCH_IDENTITY_PROVIDER_SUCCESS';
export const FETCH_IDENTITY_PROVIDER_FAILED = 'FETCH_IDENTITY_PROVIDER_FAILED';

export const FETCH_IMPORT_CERTIFICATE_REQUEST = 'FETCH_IMPORT_CERTIFICATE_REQUEST';
export const FETCH_IMPORT_CERTIFICATE_SUCCESS = 'FETCH_IMPORT_CERTIFICATE_SUCCESS';
export const FETCH_IMPORT_CERTIFICATE_FAILED = 'FETCH_IMPORT_CERTIFICATE_FAILED';
